export default __webpack_public_path__ + "static/media/BasedProps.b4267215.svg";